/**
 * A mark per reading.
 *
 * Beside the labels in the sidebar, and on its own in a rail; the loop map
 * draws the same marks so that a screen looks the same in both places. Keyed
 * off `LOOP` rather than written out, so a reading added there with no icon is
 * a compile error rather than a blank row.
 */

import {
	Activity,
	Antenna,
	ArrowDownToLine,
	Award,
	ClipboardList,
	Compass,
	FileText,
	Flag,
	GitBranch,
	Globe,
	Layers,
	Lightbulb,
	LineChart,
	Map as MapIcon,
	MessageSquare,
	Quote,
	Radar,
	Repeat2,
	Route,
	ScanEye,
	ShieldCheck,
	Split,
	Target,
	UserRound,
	Users,
} from "lucide-react";
import type { ReactNode } from "react";
import type { ReadingSlug } from "~/modules/analytics/lib/loop";

export const READING_ICONS: Record<ReadingSlug, ReactNode> = {
	visibility: <Target />,
	plans: <ClipboardList />,
	prompts: <MessageSquare />,
	fanouts: <Split />,
	platforms: <Layers />,
	regions: <MapIcon />,
	personas: <UserRound />,
	sentiment: <ScanEye />,
	citations: <Quote />,
	competitors: <Users />,
	gaps: <Lightbulb />,
	factcheck: <ShieldCheck />,
	// After the gaps, not before: a gap is a fact this product derived, and the
	// plan is what somebody made of it.
	opportunities: <Compass />,
	briefs: <ClipboardList />,
	drafts: <FileText />,
	published: <Globe />,
	// The step before every number in stage 1: whether an engine ever came to
	// read what was published.
	crawlers: <Radar />,
	badge: <Award />,
	templates: <FileText />,
	distribution: <Globe />,
	reflows: <Repeat2 />,
	since: <LineChart />,
	traffic: <ArrowDownToLine />,
	journeys: <Route />,
	goals: <Flag />,
	attribution: <GitBranch />,
	vitals: <Activity />,
	live: <Antenna />,
};
